import { useApiQuery } from "../../../../../core/api/useApiQuery"
import { StatisticGraph } from "../../../../../shared/components/statistic/StatisticGraph"
import { useSupplier } from "../../../../supplier/supplierHooks"
import { CompanyReportsHomeQuery, fetchPosNumberOfTransactions } from "../companyReportsHomeApi"

export function POSOrdersStat({ periodInDays }: { periodInDays: number }) {
    const { supplierId } = useSupplier()

    const { data } = useApiQuery(fetchPosNumberOfTransactions, {
        queryName: CompanyReportsHomeQuery.POS_NUMBER_OF_TRANSACTIONS,
        dependencies: {
            companyId: supplierId,
            periodInDays,
        },
        suspense: true,
        useErrorBoundary: true,
        refetchInterval: 30000,
        forceMock: true,
    })
    if (!data) return null

    return (
        <StatisticGraph
            changeInPercentage={data?.reportSummary?.changeInPercentage}
            labels={data.posPurchases.map((entry) => entry.date)}
            datasets={data.posPurchases.map((entry) => entry.purchasesSummary.numberOfOrders)}
            title={data?.reportSummary?.changeInPercentage}
        />
    )
}
